import React from 'react';
import PropTypes from 'prop-types';

import Product from './Product';
import Filter from './Filter';

import './ProductList.scss';

const ProductList = props => (
  <section className="product-list">
    {props.addFiltering && (
      <Filter
        filter={props.filter}
        filterOptions={props.filterOptions}
        itemsVisible={props.items.length}
        values={props.values}
        errors={props.errors}
        onHandleChange={props.handleChange}
      />
    )}
    <div className="container-guttered">
      <div className="product-list-grid">
        {props.items.map((item, i) => (
          <Product
            key={`product-${i}`}
            image={item.image}
            imageBackgroundColor={item.backgroundColor}
            badge={item.badge}
            minimumAge={item.minimumAge}
            maximumAge={item.maximumAge}
            title={item.title}
            description={item.description}
            slug={item.productSlug}
            ageString={props.productAgeLabel}
            priceString={props.productPriceLabel}
            price={item.price}
            savings={item.savings}
          />
        ))}
      </div>
    </div>
  </section>
);

ProductList.propTypes = {
  productAgeLabel: PropTypes.string.isRequired,
  productPriceLabel: PropTypes.string.isRequired,
  addFiltering: PropTypes.bool.isRequired,
  filter: PropTypes.object,
  filterOptions: PropTypes.arrayOf(PropTypes.object),
  values: PropTypes.object,
  errors: PropTypes.object,
  handleChange: PropTypes.func,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.object.isRequired,
      backgroundColor: PropTypes.string.isRequired,
      badge: PropTypes.string,
      minimumAge: PropTypes.string.isRequired,
      maximumAge: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      productSlug: PropTypes.string.isRequired
    }),
  ).isRequired
};

export default ProductList;



// WEBPACK FOOTER //
// ./src/client/js/view/components/ProductList/ProductList.js